export default __webpack_public_path__ + "static/media/Bracers of the Death God.4d5e7146.jpg";